import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'

const SLICE_NAME = 'invitedUser'

const initialState = {
	entities: {},
	ids: [],
	recents: [],
	isLoading: false,
	isInitialized: false,
}

function prepConfig(getState) {
	const {
		userLogin: { userInfo },
	} = getState()

	return {
		headers: {
			Authorization: `Bearer ${userInfo.token}`,
		},
	}
}

export const initializeInvitedUsers = createAsyncThunk(
	`${SLICE_NAME}/initialize`,
	async (payload, { getState, rejectWithValue }) => {
		try {
			return axios.get('/api/invitedusers', prepConfig(getState)).then(res => res.data)
		} catch (error) {
			return rejectWithValue('Failed to initialize users')
		}
	},
)

const invitedUserListSlice = createSlice({
	name: SLICE_NAME,
	initialState,
	reducers: {},
	extraReducers: {
		[initializeInvitedUsers.fulfilled as any]: (state, action) => {
			const users = action.payload

			state.ids = users?.map((user, index) => {
				state.entities[user._id] = user
				return user._id
			})
			state.isLoading = false
			state.isInitialized = true
		},
		[initializeInvitedUsers.pending as any]: state => {
			state.isLoading = true
		},
		[initializeInvitedUsers.rejected as any]: (state, action) => {
			state.isLoading = false
			state.isInitialized = true
			state.error = action.error.message
		},
	} as any,
})

export default invitedUserListSlice
